module.exports = __webpack_public_path__ + "img/case18.63ce63d8.png";